module.exports = __webpack_public_path__ + "img/Roger_Zimmermann@2x.f4c8cce8.png";